import request from '../../utils/request';
import { Result } from '../../models/general';
import {
  PensionCoverageView,
  GpssaRemittanceView,
  UserPensionRecordView,
  UserPensionRecordInput,
  MonthlyPensionContributionView,
  GpssaComplianceSummaryView,
  GpssaGenerationResultView,
  GpssaAutoGenerationSettingsView,
  GpssaAutoGenerationInput,
  EmiratizationSummaryView,
} from '../../models/payroll';

export async function getGpssaCoverage(year: number, month: number): Promise<Result<PensionCoverageView[]>> {
  const response = await request.get<Result<PensionCoverageView[]>>(`Gpssa/Coverage/${year}/${month}`);
  return response.data;
}

export async function getGpssaRemittance(year: number, month: number): Promise<Result<GpssaRemittanceView>> {
  const response = await request.get<Result<GpssaRemittanceView>>(`Gpssa/Remittance/${year}/${month}`);
  return response.data;
}

export async function upsertPensionRecord(input: UserPensionRecordInput): Promise<Result<UserPensionRecordView>> {
  const response = await request.post<Result<UserPensionRecordView>>('Gpssa/PensionRecord', input);
  return response.data;
}

export async function getPensionRecord(userId: string): Promise<Result<UserPensionRecordView>> {
  const response = await request.get<Result<UserPensionRecordView>>(`Gpssa/PensionRecord/${userId}`);
  return response.data;
}

export async function generateContributions(year: number, month: number): Promise<Result<GpssaGenerationResultView>> {
  const response = await request.post<Result<GpssaGenerationResultView>>(`Gpssa/GenerateContributions/${year}/${month}`);
  return response.data;
}

export async function getContributions(year: number, month: number): Promise<Result<MonthlyPensionContributionView[]>> {
  const response = await request.get<Result<MonthlyPensionContributionView[]>>(`Gpssa/Contributions/${year}/${month}`);
  return response.data;
}

export async function getGpssaComplianceSummary(year: number, month: number): Promise<Result<GpssaComplianceSummaryView>> {
  const response = await request.get<Result<GpssaComplianceSummaryView>>(`Gpssa/ComplianceSummary/${year}/${month}`);
  return response.data;
}

export async function approvePendingContributions(year: number, month: number): Promise<Result<number>> {
  const response = await request.post<Result<number>>(`Gpssa/ApprovePending/${year}/${month}`);
  return response.data;
}

export async function getGpssaAutoGenerationSettings(): Promise<Result<GpssaAutoGenerationSettingsView>> {
  const response = await request.get<Result<GpssaAutoGenerationSettingsView>>('Gpssa/AutoGenerationSettings');
  return response.data;
}

export async function updateGpssaAutoGenerationSettings(input: GpssaAutoGenerationInput): Promise<Result<GpssaAutoGenerationSettingsView>> {
  const response = await request.post<Result<GpssaAutoGenerationSettingsView>>('Gpssa/AutoGenerationSettings', input);
  return response.data;
}

export async function getEmiratizationSummary(): Promise<Result<EmiratizationSummaryView>> {
  const response = await request.get<Result<EmiratizationSummaryView>>('Gpssa/Emiratization');
  return response.data;
}
